import React from "react"
import { useSelector } from "react-redux"

export default function SocialWidget() {
    const socialLinks = useSelector((state) => state.customize.social_links)
    
    // دالة لتحويل أسماء الأيقونات من التنسيق القديم إلى تنسيق Font Awesome
    const getFontAwesomeIcon = (iconName) => {
        // إذا كان الأيقون مخزن بالفعل بتنسيق Font Awesome، نرجعه كما هو
        if (iconName?.startsWith('fa-')) {
            return iconName;
        }
        
        // تحويل أيقونات السوشيال ميديا الشائعة
        const iconMap = {
            // Facebook
            'facebook': 'fa-light fa-facebook',
            'facebook-f': 'fa-light fa-facebook-f',
            'logos:facebook': 'fa-light fa-facebook',
            
            // Twitter / X
            'twitter': 'fa-light fa-twitter',
            'x': 'fa-light fa-x-twitter',
            'logos:twitter': 'fa-light fa-twitter',
            
            // Instagram
            'instagram': 'fa-light fa-instagram',
            'logos:instagram': 'fa-light fa-instagram',
            'instagram-icon': 'fa-light fa-instagram',
            
            // LinkedIn
            'linkedin': 'fa-light fa-linkedin',
            'linkedin-in': 'fa-light fa-linkedin-in',
            'logos:linkedin': 'fa-light fa-linkedin',
            
            // YouTube
            'youtube': 'fa-light fa-youtube',
            'logos:youtube': 'fa-light fa-youtube',
            
            // Pinterest
            'pinterest': 'fa-light fa-pinterest',
            'pinterest-p': 'fa-light fa-pinterest-p',
            
            // Snapchat
            'snapchat': 'fa-light fa-snapchat',
            
            // TikTok
            'tiktok': 'fa-light fa-tiktok',
            
            // WhatsApp
            'whatsapp': 'fa-light fa-whatsapp',
            
            // Telegram
            'telegram': 'fa-light fa-telegram',
            
            // Discord
            'discord': 'fa-light fa-discord',
            
            // GitHub
            'github': 'fa-light fa-github',
            
            // Dribbble
            'dribbble': 'fa-light fa-dribbble',
            
            // Behance
            'behance': 'fa-light fa-behance',
            
            // Medium
            'medium': 'fa-light fa-medium',
            
            // Reddit
            'reddit': 'fa-light fa-reddit-alien',
            
            // Tumblr
            'tumblr': 'fa-light fa-tumblr',
            
            // Twitch
            'twitch': 'fa-light fa-twitch',
            
            // Spotify
            'spotify': 'fa-light fa-spotify',
            
            // SoundCloud
            'soundcloud': 'fa-light fa-soundcloud',
            
            // Vimeo
            'vimeo': 'fa-light fa-vimeo',
            'vimeo-v': 'fa-light fa-vimeo-v',
            
            // RSS
            'rss': 'fa-light fa-rss',
            'feed': 'fa-light fa-rss',
            
            // Website / Link
            'link': 'fa-light fa-link',
            'globe': 'fa-light fa-globe',
            'website': 'fa-light fa-globe',
            
            // Email
            'email': 'fa-light fa-envelope',
            'mail': 'fa-light fa-envelope',
        };
        
        // استخراج اسم الأيقونة من مسار Iconify (مثل: logos:facebook)
        let iconKey = iconName;
        if (iconName?.includes(':')) {
            iconKey = iconName.split(':')[1];
        }
        
        // البحث في الخريطة أو إرجاع أيقونة افتراضية
        return iconMap[iconKey] ?? 'fa-light fa-share-nodes';
    }

    return (
        <div className="cs_social_btns cs_style_1">
            {socialLinks?.social_list?.map((item, index) => (
                <a 
                    key={index} 
                    href={item?.social_url ?? "#"} 
                    className="cs_center" 
                    target="_blank" 
                    rel="noopener noreferrer"
                >
                    <i className={getFontAwesomeIcon(item?.social_icon ?? "")}></i>
                </a>
            ))}
        </div>
    )
}